import * as Yup from 'yup';

export const profileValidationSchema = Yup.object().shape({
    name: Yup.string()
        .required('Name is required'),
    surname: Yup.string()
        .required('Surname is required'),
    username: Yup.string()
        .required('Username is required'),
    email: Yup.string()
        .email('Invalid email format')
        .required('Email is required'),
    phone: Yup.string()
        .required('Phone is required'),
    profile_photo: Yup.mixed()
});

export const passwordValidationSchema = Yup.object().shape({
    current_password: Yup.string()
        .required('Current password is required'),
    new_password: Yup.string()
        .required('New password is required')
        .min(8, 'Password must be at least 8 characters'),
    new_password_confirmation: Yup.string()
        .required('Password confirmation is required')
        .oneOf([Yup.ref('new_password')], 'Passwords must match')
});

export const agencyValidationSchema = Yup.object().shape({
    name: Yup.string()
        .required('Company name is required')
        .min(2, 'Company name must be at least 2 characters'),
    email: Yup.string()
        .email('Invalid email format')
        .required('Email is required'),
    phone: Yup.string()
        .required('Phone number is required'),
    description: Yup.string(),
    image: Yup.mixed(),
    details: Yup.object().shape({
        commercial_name: Yup.string().required('Commercial name is required'),
        iban_number: Yup.string().required('IBAN number is required'),
        account_number: Yup.string().required('Account number is required'),
        swift_code: Yup.string().required('Swift code is required'),
        tax_id_number: Yup.string().required('Tax ID number is required'),
        bank_country_id: Yup.string().required('Bank country is required'),
        bank_state_id: Yup.string().required('Bank state is required'),
        currency: Yup.string().required('Currency is required').oneOf(['USD', 'EUR'], 'Invalid currency')
    }),
    address: Yup.object().shape({
        country_id: Yup.string().required('Country is required'),
        state_id: Yup.string().required('State is required'),
        city_id: Yup.string().required('City is required'),
        address: Yup.string().required('Address is required'),
        zip_code: Yup.string().required('Zip code is required')
    })
}); 